export default "__VITE_ASSET__6E4iCGJr__"